import {confirmAlert} from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import "../assets/css/App.css"
import React from "react";
import OpsBtn from "./ops-btn";
import OpsText from "./ops-text";

export const opsConfirmDialog = (
    title,
    subtitle,
    theme,
    actionYes,
    actionNo,
    content,
) => {
    confirmAlert({
        closeOnClickOutside: false,
        customUI: ({onClose}) => {
            return (
                <div className="ops-dialog-container p-4 me-4 ms-4 shadow"
                     data-theme={theme}>
                    <OpsText type="title" weight={600} color="primary-3"
                             content={title}/>
                    <OpsText type="subtitle" className="w-75 my-2" color="color-1"
                             content={subtitle}/>
                    {content}

                    <div className="desktop-row-phone-col gap-2 mt-5 w-100 justify-content-center">
                        <OpsBtn
                            text="Zrušiť"
                            variant="secondary"
                            size="md mt-2"
                            action={() => {
                                actionNo();
                                onClose();
                            }}
                        />
                        <OpsBtn
                            text="Potvrdiť"
                            variant="primary"
                            size="md mt-2"
                            action={() => {
                                actionYes();
                                onClose();
                            }}
                        />
                    </div>
                </div>
            );
        },
    });
};

